module.exports = __webpack_public_path__ + "media/images/front/ad_450-180-9b6ed830b2df6fce250ebaaddeb6caa2.jpg";